//
// Header.js
//
// author: marcio.garcia@newsoftware.com.br
//

import React from 'react'
import { Link } from 'react-router-dom'
//import { withRouter } from 'react-router-dom';

import ContentService from '../services/ContentService';

import { msg } from '../defs/lang'


class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = { value: '' };
        
    }

    loadContent(name){
        document.title = msg.txtTitle + " | "+name;
    }

    componentDidMount() {
        this.loadContent(this.props.content);
    }

    componentWillReceiveProps(nextProps) {
        this.loadContent(nextProps.content);
    }

    onChange = (event) => {
        this.setState({ value: event.target.value });
    }

    onSubmit = (event) => {
        event.preventDefault();
        const encodedString = new Buffer(this.state.value).toString('base64');
        //const { history } = this.props;
        const path = `/search/${encodedString}`;
        this.props.history.push(path);
    }


    render() {
        const name = this.props.content;
        const contentList =  ContentService.getContentList('menu');

        return (
            <header id="header">
                <div className="wrap">
                    <Link to="/" className="logo" >
                        <img src="images/logo.svg" alt="Logo" />
                    </Link>
            
                    <nav>
                        {contentList.map(item => {
                            const page = ContentService.getContentItem(item.id);
                            return    <Link   
                                    to={"/content/"+item.id} 
                                    key={item.id}
                                    className={(item.id===name)?'selected':name}>
                                    {page.title}
                                </Link>}
                        )}
                        <form id="nse-head-form" onSubmit={this.onSubmit} >
                            <input type="text"
                                placeholder={msg.txtSearch}
                                value={this.state.value}
                                name="nse-search-field"
                                onChange={this.onChange}
                                className="nse-search-field" />
                            <input type="submit" name="nse-search-button" className="nse-search-button" />
                            <Link to="/content/Contact" className="nse-contact-button" >Ct</Link>

                        </form>
                    </nav>
                </div>
            </header>
        )
    }

}

export default Header;
//export default withRouter(Header);
